<div style="display: contents" *ngIf="!selectProyectos">
  <h1 class="textS+" style="text-align: center; height: 10%" mat-dialog-title>
    {{this.localiser.get("newUser.title")}} {{this.data.empresa.nombre}}
  </h1>

  <div mat-dialog-content class="bodyForm">
    <div class="row rowForm">
      <div class="col">
        <h4 class="textS+">{{this.localiser.get("profile.name")}}</h4>
        <input [(ngModel)]="nombre" type="text" class="inputWidth textS" maxlength="25">
      </div>
      <div class="col">
        <h4 class="textS+">{{this.localiser.get("profile.surname")}}</h4>
        <input [(ngModel)]="apellidos" type="text" class="inputWidth textS" maxlength="40">
      </div>
    </div>
    <div class="row rowForm">
      <div class="col">
        <h4 class="textS+">{{this.localiser.get("profile.email")}}</h4>
        <input [(ngModel)]="email" type="text" class="inputWidth textS" maxlength="60">
      </div>
      <div class="col">
        <h4 class="textS+">{{this.localiser.get("profile.phone")}}</h4>
        <input [(ngModel)]="telefono" type="text" class="inputWidth textS" maxlength="25">
      </div>
    </div>
    <div class="row rowForm">
      <div class="col">
        <h4 class="textS+">{{ this.localiser.get("profile.licenseExpiryDate") }}</h4>
        <input [(ngModel)]="licenseExpiryDate" type="date" class="inputWidth textS">
      </div>
      <div class="col">
      </div>
    </div>
    <div class="row rowForm">
      <div class="col">
        <h4 class="textS+">{{this.localiser.get("users.permissions")}}</h4>
        <mat-select class="selectPermisos textS" [(ngModel)]="idPermiso">
          <mat-option class="textS" value="Ateneo">{{this.localiser.get("users.ateneo")}}</mat-option>
          <mat-option class="textS" value="Configuración">{{this.localiser.get("users.configuration")}}</mat-option>
        </mat-select>
      </div>
    </div>

    <div *ngIf="feedback < 0" class="col errorMessage">
      {{whichMessage()}}
    </div>


    <div *ngIf="charging" class="col">
      <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" diameter="40">
      </mat-progress-spinner>
    </div>

  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button (click)="newUser()">{{this.localiser.get("button.create")}}</button>
    </div>
  </div>

</div>

<div style="display: contents" *ngIf="selectProyectos">
  <h1 class="textS+" style="text-align: center; height: 10%" mat-dialog-title>
    {{this.localiser.get("newUser.addProjects")}} {{data.empresa.nombre}} {{this.localiser.get("newUser.forTheUser")}} {{usuario.nombre}} {{usuario.apellidos}}
  </h1>

  <div mat-dialog-content class="bodyForm" *ngIf="data.empresa.proyectos.length > 0">
    <div *ngFor="let proyecto of data.empresa.proyectos" style="text-align: center">
      <mat-checkbox class="textS+" (change)="change(proyecto.idProyecto, $event.checked)">
        {{proyecto.nombre}}
      </mat-checkbox>
    </div>
  </div>

  <div mat-dialog-content class="bodyForm" *ngIf="data.empresa.proyectos.length <= 0">
    <div class="middleText">
      <h3 class="textM centerVert">{{this.localiser.get("users.noProjects")}} {{this.data.empresa.nombre}}</h3>
    </div>
  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
  </div>

</div>

